module.exports = __webpack_public_path__ + "img/pain-spot-2.ec8061ba.svg";